import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import BasicValidation from "../../components/Forms/AddDirectory";
import AdvancedValidation from "../../components/Forms/AdvancedValidation";
import AddDirectory from "../../components/Forms/AddDirectory";
import AddCategory from "../../components/Forms/AddCategory";
import AddNews from "../../components/Forms/AddNews";
import AddEvents from "../../components/Forms/AddEvents";
import AddBloodBank from "../../components/Forms/AddBloodBank";

class FormAddBloodBank extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Validation"
              Breadcrumb={[
                { name: "Form", navigate: "" },
                { name: "Validation", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <AddBloodBank />
            </div>
            <div className="row clearfix">
              {/* <AdvancedValidation /> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({});

export default connect(mapStateToProps, {})(FormAddBloodBank);
